import axios from "axios";
import state from "../store";

let baseUrl = state.getters.mainAppURL + "branches_qr_details/";
const updateQRStatus = (branchId, isDeleted) =>  axios.put(`${baseUrl}${branchId}/${isDeleted}`);

export {
    updateQRStatus
}